import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { LojaIntegradaOverviewMessages } from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-overview.messages";

interface Props {
  messages: LojaIntegradaOverviewMessages;
}

export function LojaIntegradaOverview({ messages }: Props) {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {messages.lojaIntegradaOverviewText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.lojaIntegradaOverviewText2}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
